import React from 'react';
import './FullScreenLoader.css'; // Import CSS untuk styling

const FullScreenLoader = ({ isLoading }) => {
  return (
    <div className={`full-screen-loader ${isLoading ? 'show' : 'hide'}`}>
      <div className="loader" />
    </div>
  );
};

export default FullScreenLoader;